import React from 'react'
import Show from 'services/Show';
import Expert from 'services/Expert';

import { handleErrors, formatDate } from 'services/utils'
import { Spinner } from 'components/atoms';
import './ring_report.sass';
import PrinterSelect from 'components/PrinterSelect';
import PrintButton from 'components/PrintButton';


export default class ShowExpertRingReport extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      show: {},
      expert: {},
      breeds: [],
      breedIds: [],
      cellsInRow: 4,
      showId: match.params.id,
      expertId: match.params.expertId,
      successSave: false,
    }
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    const showPromise = Show.get(this.state.showId).then(show => {
      if (this.mounted) {
        this.setState({ show });
      }
    }).catch((request) => {
      handleErrors(request);
    });
    const expertPromise = Expert.withRingReports(this.state.expertId, this.state.showId).then( expert => {
      if (this.mounted) {
        const breedIds = [expert.breeds[0].id];
        this.setState( { expert, breedIds } );
      }
    });
    expertPromise.catch((request) => {
      handleErrors(request);
    });
    Promise.all([showPromise, expertPromise]).then(()=> {
      if (this.mounted) {
        this.setState({ loading: false });
      }
    });
  }

  toggleBreed = ({target}) => {
    const bId = parseInt(target.value);
    let breedIds;
    if (target.checked) {
      breedIds = [...this.state.breedIds, bId];
    } else {
      breedIds = this.state.breedIds.filter(breedId => breedId !== bId);
    }
    this.setState({ breedIds });
  }

  toggleAllBreeds = ({target}) => {
    let breedIds = [];
    if (target.checked) {
      breedIds = this.state.expert.breeds.map(breed => breed.id);
    }
    this.setState({ breedIds });
  }

  onCellsInRowChange = ({target:{value}}) => {
    this.setState({cellsInRow: value});
  }


  render() {
    const {show, expert, breedIds, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    const breedOptions = expert && expert.breeds ? (expert.breeds || []).map(breed => {
      return  <div key={breed.id}  className="form-group form-check col-xl-3 col-lg-4 col-md-6">
                <input type="checkbox" className="form-check-input" id={'breed'+breed.id} value={breed.id} 
                  checked={breedIds.includes(breed.id)} onChange={this.toggleBreed} />
                <label className="form-check-label" htmlFor={'breed'+breed.id}>
                  {breed.name} ({breed.nums[0]} - {breed.nums[breed.nums.length-1]})
                </label>
              </div>
    }) : null;

    const allBreedsChecked = expert && expert.breeds && breedIds.length === expert.breeds.length;

    return (
      <div className="container-fluid">
        <div className="no-print">
          <h4>{showInfo}</h4>
          <h5>Печать ринговых ведомостей эксперта {expert.name}</h5>
          <div className="row mb-2">
            <div className="col-2">
              <label>Кол-во ячеек в ряду</label>
              <input type="number" min="1" max="20" className="form-control" 
                value={this.state.cellsInRow} onChange={this.onCellsInRowChange} />
            </div>
            <div className="col-3">
              <label>Принтер</label>
              <PrinterSelect className="form-control" orientation="portrait" />
            </div>
            <div className="col-2">
              <label className="row">&nbsp;</label>
              <PrintButton disabled={!breedIds.length} />
            </div>
          </div>
          <h3>Породы для печати</h3>
          {expert && expert.breeds ? <div className="form-group form-check">
            <input type="checkbox" className="form-check-input" id="all-breeds" value="all"
              checked={allBreedsChecked} onChange={this.toggleAllBreeds} />
            <label className="form-check-label" htmlFor="all-breeds">Все породы</label>
          </div> : null}
          <div className="row mb-5">
            {breedOptions}
          </div>
          {loading && <Spinner /> }
        </div>
        {breedIds.map(breedId => <BreedRingReport key={breedId} breedId={breedId} 
          expert={expert} show={show}
          cellsInRow={this.state.cellsInRow} />) }
      </div>
    );
  }
}


function BreedRingReport({show, expert, breedId, cellsInRow}) {
  const bId = parseInt(breedId);
  if (!show || !expert || !expert.breeds || !bId) return null;
  const breed = expert.breeds.find(breed => breed.id === bId);
  if (!breed) return null;
  let rows = [];
  let numCells = [];
  let blankCells = [];
  
  function addRow() {
    if (!numCells.length) return;
    let rowNum = 1 + rows.length;
    rows.push(
      <tr key={'num'+rowNum}>
        <th>№ кат.</th>
        {numCells}
      </tr>
    );
    rows.push(
      <tr key={'res'+rowNum}>
        <th>Оценка<br/>Титул</th>
        {blankCells}
      </tr>
    );
    numCells = [];
    blankCells = [];
  }

  breed.nums.forEach((num, i) => {
    numCells.push(<th key={'numcel-'+i}>{num}</th>);
    blankCells.push(<td key={'rescel-'+i}></td>);
    if ((i+1)%cellsInRow === 0) {
      addRow();
    }
  });
  addRow();

  return (
    <div className="ring-report print-page">
      <p className="show-name">
        Название и ранг выставки / dog show details 
        &nbsp;
        <strong>"{show.name}"</strong>
      </p>
      <h5 className="show-description">Международная выставка собак всех пород CACIB-FCI, CFC-BY</h5>
      <h4 className="show-date">{formatDate(show.starts_at)}</h4>
      <h4 className="expert">
        <div className="ring-num"><i>Ринг №</i> {expert.ring}</div>
        <i>Судья:</i> {expert.name} ({expert.country_name})
      </h4>
      <div className="breed-name"><i>Порода:</i> {breed.name} / {breed.name_lat}</div>
      <table className="dogs-table">
        <tbody>
        {rows}
        </tbody>
      </table>
      <div className="row">
        <ul className="col-5">
          <li><span>JCAC</span></li>
          <li><span>CAC</span></li>
          <li><span>CACIB</span></li>
          <li><span>RCACIB</span></li>
          <li><span>ЛППБ "ЗОРКА БЕЛАРУСИ"</span></li>
        </ul>
        <div className="col-2">&nbsp;</div>
        <ul className="col-5">
          <li><span>BEST BABY</span></li>
          <li><span>BEST PUPPY</span></li>
          <li><span>BEST VETERAN</span></li>
          <li><span>BEST JUNIOR</span></li>
          <li><span>ВОВ/ЛПП</span></li>
        </ul>
      </div>
      <div className="row mt-3 signatures">
        <div className="col-5">Ответственный за ринг</div>
        <div className="col-2">&nbsp;</div>
        <div className="col-5">Подпись судьи</div>
      </div>
    </div>
  );
}